import useAxios, { UseAxiosResult } from 'axios-hooks';

export default function useTcrVerticals(): UseAxiosResult<object> {
  return useAxios<object>({
    url: 'tcr-enums/verticals',
    method: 'GET'
  });
}
